import React, { useEffect } from 'react'
import css from './ListingCardBox.module.css';
import { NamedLink, ResponsiveImage } from '../../components';
import { createSlug } from '../../util/urlHelpers';


const ImageSwiper = ({images, id, slug}) => {
  useEffect(() => {
    // Initialize Swiper
    setTimeout(function() {
      new Swiper('.img-swiper-container', {
        loop: true,
        slidesPerView: 1,
        speed: 500,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }, 500);
  }, []);

  return (
    <div className="img-swiper-container" data="img-swiper-container">
      <div className="swiper-wrapper" data="img-swiper">
        {images?.map((src, index) => (
          <div className="swiper-slide" key={index} data="img-swiper-slide">
            <NamedLink
              name="ListingPage"
              params={{ id, slug }}
              className={css.cardLink}
            >
              <ResponsiveImage
                rootClassName={css.cardImg}
                alt="card img"
                image={src}
                variants={Object.keys(src?.attributes?.variants).filter(k => k.startsWith("listing-card"))}
              />
            </NamedLink>
          </div>
        ))}
      </div>
      <div class="swiper-pagination" data="data-pagination"></div>
    </div>
  )
}
export default ImageSwiper;

